import React from 'react'
import {Button} from 'react-bootstrap'
import {FieldGroup} from '../helpers/form'
import _ from 'lodash'
import {withRouter} from 'react-router-dom'
import axios from 'axios'
import logo from '../images/header-canfax.png'

@withRouter
export default class ContactUs extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      message: '',
      isSubmitting: false,
      submitted: false,
      didSubmitSuccessfully: false,
    }
  }

  componentWillMount() {
    this.setState({
      firstName: '',
      lastName: '',
      email: '',
      message: '',
      isSubmitting: false,
      submitted: false,
      didSubmitSuccessfully: false,
    })
  }

  handleValueChanged = (event) => {
    this.setState({[event.target.id]: event.target.value})
  }

  handleSubmit = (event) => {
    event.preventDefault()
    this.setState({submitted: true})

    const {firstName, lastName, email, message} = this.state
    if (
      _.isNil(firstName) ||
      _.isEmpty(firstName) ||
      _.isNil(lastName) ||
      _.isEmpty(lastName) ||
      _.isNil(email) ||
      _.isEmpty(email) ||
      _.isNil(message) ||
      _.isEmpty(message)
    ) {
      return
    }

    // Daniel Local email testing
    // let emailUrl = 'http://cfxpro.devlocal/email.php'
    let emailUrl =
      window.location.protocol + '//' + window.location.host + '/email.php'

    var body = ''
    body += `Contact Us Request from:<br /><br />`
    body += `Name: ${firstName} ${lastName}<br />`
    body += `Email: ${email}<br />`
    body += `Message: ${message}<br />`

    this.setState({isSubmitting: true})
    axios
      .post(emailUrl, {
        to: process.env.NODE_ENV,
        subject: 'Contact Us',
        body: body,
      })
      .then((response) => {
        this.setState({isSubmitting: false})
        if (response && response.data.status === 'ok') {
          console.log('Email Sent!')
          this.setState({didSubmitSuccessfully: true})
        } else {
          console.log('Email failed to send!', response)
          window.alert('Email Failed to send!')
        }
      })
      .catch((err) => {
        this.setState({isSubmitting: false})
        console.log('Error sending email', err)
        window.alert('Email Failed to send!')
      })
  }

  render() {
    const {
      firstName,
      lastName,
      email,
      message,
      submitted,
      isSubmitting,
      didSubmitSuccessfully,
    } = this.state

    return (
      <div className="contact-us clearfix">
        {didSubmitSuccessfully ? (
          <ContactUsFormSubmitted />
        ) : (
          <div>
            <h1>Contact Us/Report Prices</h1>
            <p>
              If you would like to report a sale, please add the following
              information in the message box below. All information comes
              directly to Canfax and is strictly confidential.
            </p>
            <p> Information needed to report a sale:</p>
            <ul>
              <li>Producer name</li>
              <li>Date of the sale</li>
              <li>Number of head</li>
              <li>Animal type (strs, heifers, cows, feeders)</li>
              <li>Price (delivered or picked-up)</li>
              <li>Pickup/delivery date, and buyer</li>
            </ul>
            <p>
              If you prefer, call the Canfax office at (403) 275-5110 and report
              prices to an analyst directly.
            </p>
            <ContactUsForm
              submitted={submitted}
              firstName={firstName}
              lastName={lastName}
              email={email}
              message={message}
              isSubmitting={isSubmitting}
              handleValueChanged={this.handleValueChanged}
              handleSubmit={this.handleSubmit}
            />
          </div>
        )}
      </div>
    )
  }
}

class ContactUsForm extends React.Component {
  render() {
    const {
      firstName,
      lastName,
      email,
      message,
      submitted,
      isSubmitting,
      handleValueChanged,
      handleSubmit,
    } = this.props

    return (
      <form onSubmit={handleSubmit} style={{marginBottom: '50px'}}>
        <div className="col-sm-12 col-md-6">
          <FieldGroup
            id="firstName"
            type="text"
            label="First Name"
            placeholder="Enter First Name"
            onChange={handleValueChanged}
            value={firstName}
          />
          {submitted &&
            firstName.length === 0 && (
              <div className="help-block">Please enter your first name</div>
            )}
        </div>
        <div className="col-sm-12 col-md-6">
          <FieldGroup
            id="lastName"
            type="text"
            label="Last Name"
            placeholder="Enter Last Name"
            onChange={handleValueChanged}
            value={lastName}
          />
          {submitted &&
            lastName.length === 0 && (
              <div className="help-block">Please enter your last name</div>
            )}
        </div>
        <div className="col-sm-12">
          <FieldGroup
            id="email"
            type="text"
            label="Email"
            placeholder="Enter Email"
            onChange={handleValueChanged}
            value={email}
          />
          {submitted &&
            email.length === 0 && (
              <div className="help-block">Please enter your Email</div>
            )}
        </div>
        <div className="col-sm-12">
          <FieldGroup
            id="message"
            componentClass="textarea"
            label="Message"
            placeholder="Comments, concerns or suggestions? Express them here!"
            onChange={handleValueChanged}
            value={message}
          />
          {submitted &&
            message.length === 0 && (
              <div className="help-block">Please enter a message!</div>
            )}
        </div>
        <Button
          type="submit"
          style={{marginLeft: '20px'}}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <i className="fa fa-spinner fa-spin" />
          ) : (
            <i className="fa fa-envelope" />
          )}{' '}
          Submit
        </Button>
      </form>
    )
  }
}

const ContactUsFormSubmitted = (props) => {
  return (
    <div className="content" style={{textAlign: 'center'}}>
      <img
        src={logo}
        alt="CanFax Logo"
        style={{paddingTop: '10px', paddingBottom: '10px'}}
      />
      <p style={{color: 'white', fontSize: '26px', fontWeight: 'bold'}}>
        Thank you for Contacting Us!<br />We'll get back to you as soon as
        possible!
      </p>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/contact.js